import React from 'react';

import { sanitize, marked } from '../../common/utils';

const copy = ``;

const About = () => (
  <div className="About">
    <h1>About this map</h1>
    <p className="about__copy" dangerouslySetInnerHTML={{ __html: sanitize(marked(copy)) }} />
    <h2><strong>ForestMapper</strong> Features:</h2>
    <h3>Robust Science</h3> 
    <p><strong>ForestMapper</strong> is comprised of 36 geospatial data layers that visually identify the world's ancient and endangered forests*. This is a tool developed by Canopy that coalesces data from:</p>
    <ul>
      <li>Leading biodiversity science institutions</li>
      <li>Academic institutions</li>
      <li>Environmental non-governmental organizations</li>
      <li>Forest industry working groups</li>
    </ul>

    <h3>Suggestions to Identify Supply Chain Risk</h3>

    <p><strong>ForestMapper</strong> is designed to: </p>
    <ul>
      <li>Assist companies transitioning to more sustainable supply chains and purchasing practices.</li>
      <li>Help identify areas of potential sourcing risk. This tool is not intended to be used as a last point of information.</li>
    </ul>  
    <h3>Ways to Learn More</h3>
    <p>Visit <a href="https://canopyplanet.org/tools/ForestMapper">canopyplanet.org/tools/ForestMapper</a> to learn more about:</p>
    <ul>
      <li>Interactive ways to explore ForestMapper</li>
      <li>ForestMapper methodology and science</li>
      <li>Full list of company adopters and scientific supporters</li>
      <li>Clarity on what the maps are and are not</li>
      <li>Actions you can take for the world's forests</li>
    </ul>

    <div className="fineprint">
      <p><strong>*</strong> A landscape will show up as ancient and endangered forest if at least one of the ecological components is present in the area, this could be, for example, a high level of soil carbon or threatened bird species.</p>

      <p>Development of <strong>ForestMapper</strong> has been solely under the control of Canopy and not of the tool's collaborators, endorsers, or adopters.</p>

      <p>Interactive map development and design by GreenInfo Network</p>
      <img className="greeninfo" alt="greeninfo network logo" src="./assets/images/greeninfo-logo.png" />
    </div>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/Lightbox/About.jsx